export default __webpack_public_path__ + "static/media/strong-4-live-class.f81f08a7.webp";